import { render, staticRenderFns } from "./ClaimStatusDialog.vue?vue&type=template&id=32d88477&"
import script from "./ClaimStatusDialog.vue?vue&type=script&lang=js&"
export * from "./ClaimStatusDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports